import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../config/axios';
import { Polyline, Tooltip } from 'react-leaflet';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from '../../../../features/notificationSlice';
import { gradient } from '../../../../utils/mapFunctions';

function DirectForLine(props) {
  const { startPoint, endPoint } = props;
  const [directData, setDirectData] = useState([]);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    setDirectData([]);
    async function getDirectData() {
      try {
        const url = `/api/segment/find-street?slat=${startPoint.lat}&slng=${startPoint.lng}&elat=${endPoint.lat}&elng=${endPoint.lng}&type=distance`;
        const result = await axiosInstance.get(url);
        if (result.data.data.length > 0) {
          setDirectData(result.data.data);
        } else {
          dispatch(
            enqueueSnackbar({
              message: t('NotFoundRoadError'),
              options: {
                variant: 'error',
              },
            })
          );
          setDirectData([]);
        }
      } catch (error) {
        setDirectData([]);
        console.log(error);
      }
    }
    if (startPoint.lat && endPoint.lat) {
      getDirectData();
    }
  }, [startPoint, endPoint, dispatch, t]);
  let firstDirectCoords = [];
  let firstDistance = 0;
  let firstStartDirectPoint = [];
  let firstEndDirectPoint = [];
  if (directData && directData.length > 0 && directData[0].coords) {
    firstDirectCoords = directData[0].coords;
    firstDistance = directData[0].distance
      ? (directData[0].distance / 1000).toFixed(1)
      : 0;
    const firstStartLat = directData[0].coords[0].lat;
    const firstStartLng = directData[0].coords[0].lng;
    firstStartDirectPoint = [firstStartLat, firstStartLng];
    const firstEndLat =
      directData[0].coords[directData[0].coords.length - 1].elat;
    const firstEndLng =
      directData[0].coords[directData[0].coords.length - 1].elng;
    firstEndDirectPoint = [firstEndLat, firstEndLng];
  }
  return (
    <>
      {firstDirectCoords &&
        firstDirectCoords.length > 0 &&
        firstDirectCoords.map((coords) => (
          <Polyline
            key={coords.segment_id}
            positions={[
              [coords.lat, coords.lng],
              [coords.elat, coords.elng],
            ]}
            pathOptions={{
              color: gradient(coords.status.velocity / 60),
              weight: 5,
            }}
          >
            <Tooltip>{`${t('Distance')} : ${firstDistance} km`}</Tooltip>
          </Polyline>
        ))}

      {firstStartDirectPoint.length > 0 && (
        <Polyline
          positions={[startPoint, firstStartDirectPoint]}
          pathOptions={{
            color: '#BBBDBF',
            dashArray: '5 10',
          }}
        />
      )}
      {firstEndDirectPoint.length > 0 && (
        <Polyline
          positions={[endPoint, firstEndDirectPoint]}
          pathOptions={{
            color: '#BBBDBF',
            dashArray: '5 10',
          }}
        />
      )}
    </>
  );
}

export default DirectForLine;
